import './OHIFLogo.css';

import React from 'react';

function OHIFLogo() {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="header-brand"
      href="https://aslsofthouse.com.br/"
    >
      <div name="ohif-logo" className="header-logo-image"></div>
    </a>
  );
}

export default OHIFLogo;
